<template>
    <div>
        <div v-for="pet in userPets" :key="pet.pid">
            <div style="margin-bottom:10px">
                <span style="margin-right:100px">宠物ID: {{ pet.pid }}</span>
                <span>宠物昵称: {{ pet.pet_account.nickname }}</span>
            </div>
            <el-table 
                :data="pet.did_list"
                style="width: 100%; margin-bottom: 50px;" 
                :stripe="true">
                <el-table-column label="数据库DID" prop="did" align="center" width="120"></el-table-column>
                <el-table-column label="串号" prop="serial_code" align="center" width="180"></el-table-column>
                <el-table-column label="绑定时间" prop="time" align="center"></el-table-column>
                <el-table-column label="电量" prop="battery" align="center" width="120"></el-table-column>
                <el-table-column label="操作" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {getUserInfo} from '../api'
export default {
    data() {
        return {
            userPets: []
        };
    },
    mounted() {
        var qUid = this.$route.query['uid'];
        console.log('user uid query:', qUid);
        getUserInfo(qUid).then((data) => {
            this.userPets = data.data.data.user_pets;
            console.log('UserPets:', this.userPets);
        });
    },
    methods: {
        handleClick(row) {
            console.log(row);
            var infoUrl = '/beltinfo?did=' + row.did + '&sc=' + row.serial_code;
            console.log(infoUrl);
            this.$router.push(infoUrl);
        }
    }
}
</script>